export default (graphQLClient, { sortKeyApplied, shouldBeReverse, handle }) => {
  console.log('Hello world from js buy sdk');
  const sortKey = graphQLClient.variable(
    'sortKey',
    'ProductCollectionSortKeys'
  );
  const testQuery = graphQLClient.query([sortKey], (root) => {
    root.add(
      'collectionByHandle',
      { args: { handle: handle } },
      (collection) => {
        collection.add('id');
        collection.add('handle');
        collection.add('description');
        collection.add('descriptionHtml');
        collection.add('updatedAt');
        collection.add('title');
        // collection.add('image');
        collection.addConnection(
          'products',
          {
            args: {
              sortKey: sortKey,
              first: 20,
              reverse: shouldBeReverse,
              query: 'inventory_total:>0',
            },
          },
          (product) => {
            product.add('id');
            product.add('availableForSale');
            product.add('createdAt');
            product.add('updatedAt');
            product.add('descriptionHtml');
            product.add('description');
            product.add('handle');
            product.add('productType');
            product.add('title');
            product.add('vendor');
            product.add('publishedAt');
            product.add('onlineStoreUrl');

            product.add('options', (options) => {
              options.add('name');
              options.add('values');
            });

            product.addConnection(
              'images',
              { args: { first: 250 } },
              (images) => {
                images.add('originalSrc');
              }
            );

            product.addConnection(
              'variants',
              { args: { first: 250 } },
              (variant) => {
                variant.add('id');
                variant.add('title');
                variant.add('price');
                variant.add('quantityAvailable');
                variant.add('priceV2', (price) => {
                  price.add('amount');
                  price.add('currencyCode');
                });
                variant.add('weight');
                variant.add('sku');
                variant.add('compareAtPrice');
                variant.add('compareAtPriceV2', (price) => {
                  price.add('amount');
                  price.add('currencyCode');
                });

                variant.add('image', (image) => {
                  image.add('id');
                  image.add('src');
                });
                variant.add('selectedOptions', (opts) => {
                  opts.add('name');
                  opts.add('value');
                });
                variant.add('unitPrice', (price) => {
                  price.add('amount');
                  price.add('currencyCode');
                });
              }
            );
          }
        );
      }
    );
  });

  return graphQLClient.send(testQuery, {
    sortKey: sortKeyApplied,
  });
};
